import axios from 'src/utils/axios';

class SearchIndexService {

  deleteIndex = (index) =>
    axios.delete(`/api/search/index/mapping?index=${index}`);

  reIndex = (index, collectionName) =>
    axios.post(
      `/api/search/addIndex?index=${index}&collectionName=${collectionName}`,
      {},
      { timeout: 60000 }
    );
}

const searchIndexService = new SearchIndexService();

export default searchIndexService;